/**
 * During the appointment booking process the users can fill out a total of three forms.
 * 1. Facility form: Can limit the list of selectable appointment types
 * 2. Appointment Type form: Can limit the available selectable slots
 * 3. Pre-Submission form: If defined - mandatory form in order to finish the appointment request submission
 */

export const FACILITY_FORM_KEY = 'facilityFormId';
export const APPOINTMENT_TYPE_FORM_KEY = 'appointmentTypeFormId';
export const PRE_SUBMISSION_FORM_KEY = 'preSubmissionFormId';

export const appointmentRequestFormKeys = [
  FACILITY_FORM_KEY,
  APPOINTMENT_TYPE_FORM_KEY,
  PRE_SUBMISSION_FORM_KEY,
];
